import { render } from "./ModalXD.vue?vue&type=template&id=f28cd64c&scoped=true"
import script from "./ModalXD.vue?vue&type=script&lang=js"
export * from "./ModalXD.vue?vue&type=script&lang=js"

import "./ModalXD.vue?vue&type=style&index=0&id=f28cd64c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28cd64c"]])

export default __exports__